import { EnvironmentProviders, Provider, importProvidersFrom, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { EventDetailsModalProxy } from '@frontend/sports/event-details/common/feature';
import { OVERLAY_INTEGRATION } from '@frontend/sports/popup/feature';
import { PrettyUrlLanguageSwitcherProvider } from '@frontend/sports/routing/pretty-urls/feature';
import { extModules } from '@frontend/sports/web/environments';
import { ROUTE_PROCESSOR } from '@frontend/vanilla/core';
import { PRODUCT_LANGUAGE_SWITCHER_URLS_PROVIDER } from '@frontend/vanilla/features/language-switcher';

import { SportsWebLazyBootstrapService } from './bootstrap/sports-web-lazy-bootstrap.service';
import { SportsRouteProductProcessor } from './routing/sports-route-product-processor';

/**
 * Provides services needed for integrating Sports-Web into Host-App.
 * These services are not needed for starting Sports-Web as a standalone app.
 * They must be provided on route level for sports-web routes.
 * @returns Providers needed for Sports-Web integration.
 */
export function provideSportsWebHostApp(): (Provider | EnvironmentProviders)[] {
    return [
        // Host-App specific
        SportsWebLazyBootstrapService,
        {
            provide: ROUTE_PROCESSOR,
            useClass: SportsRouteProductProcessor,
            multi: true,
        },
        {
            provide: PRODUCT_LANGUAGE_SWITCHER_URLS_PROVIDER,
            useClass: PrettyUrlLanguageSwitcherProvider,
        },
        // External providers
        importProvidersFrom(extModules),
        importProvidersFrom(MatDialogModule),
        {
            provide: OVERLAY_INTEGRATION,
            useFactory: () => {
                const modalService = inject(EventDetailsModalProxy);

                return {
                    isOverlayOpen: () => modalService.isOpen(),
                };
            },
        },
    ];
}
